import React, { useEffect, useState } from "react";
import Header from "../component/layout/Header";
import "../index.css";
import finalImage from "../assets/final.jpg";
import FinalMobileImage from "../assets/finalM.jpg"
import Carousel from "../component/carousel/Carousel";
import Hero from "../component/Hero/Hero";
import Cookies from "js-cookie"
import Footer from "../component/layout/Footer";
import { FaMapMarkerAlt } from "react-icons/fa";
import { DietFilterOption } from "../component/Menu/DietFilterOption";
import { AiOutlineClose } from "react-icons/ai";
import { TiTick } from "react-icons/ti";
import api from "../utils/api";
import { MdInfoOutline } from "react-icons/md";
import { useDispatch } from "react-redux";
import { Tooltip } from 'react-tooltip';

import { setRestaurantId } from "../../src/redux/restaurantSlice";
import { loadFromLocalStorage, saveToLocalStorage } from "../redux/helpers/localStorage";
import ForgotPassword from "../component/User/Forgot-Password/ForgotPassword";
import { CgCheck, CgClose } from "react-icons/cg";
import { LuMapPinCheck } from "react-icons/lu";
const HomePage = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [iconSize, setIconSize] = useState(34); // Default size for large screens (lg)
  const [selectedOption, setSelectedOption] = useState(null); // Track the selected option's index
  const [selectedRestaurant, setSelectedRestaurant] = useState(null)
  // console.log("selectedRestaurant", selectedRestaurant)
  const [selectedRestaurantName, setSelectedRestaurantName] = useState(""); // State to hold selected restaurant name
  const dispatch = useDispatch();
  // Function to fetch restaurant data
  const [hoveredId, setHoveredId] = useState(null)
 const [restaurants, setRestaurants] = useState([]); // State to store 
  const fetchRestaurantData = async () => {
    try {
      const response = await api.get("/restaurant");
      const fetchedRestaurants = response.data.results;
  
      setRestaurants(fetchedRestaurants);
 
      console.log("fetchedRestaurants", fetchedRestaurants);
  
    
      fetchedRestaurants.forEach(restaurant => {
  saveRestaurantStatusToLocalStorage(restaurant._id, restaurant.isActive, restaurant?.holidays);
});
  
      const savedRestaurantId = loadFromLocalStorage("selectedRestaurantId");
      const savedRestaurantName = fetchedRestaurants.find(
        (restaurant) => restaurant._id === savedRestaurantId
      )?.title;
  
      if (savedRestaurantId && savedRestaurantName) {
        dispatch(setRestaurantId(savedRestaurantId));
        setSelectedRestaurantName(savedRestaurantName);
        setSelectedOption(
          fetchedRestaurants.findIndex((restaurant) => restaurant._id === savedRestaurantId)
        );
      } else if (fetchedRestaurants.length > 0) {
        
        // dispatch(setRestaurantId(fetchedRestaurants[0]._id));
        // setSelectedRestaurantName(fetchedRestaurants[0].title);
        // setSelectedOption(0);
      }
    } catch (error) {
      console.error("Error fetching restaurant data:", error);
    }
  };
  
  // Function to check if the restaurant is open
  function checkIfRestaurantIsOpen(restaurant) {
    const currentDay = new Date().toLocaleString("en-us", { weekday: "long" });
    const currentTime = new Date().toISOString().slice(11, 16);
  
    const dayHours = restaurant.weeks.find((day) => day.day === currentDay);
  
    if (!dayHours) {
      return false; // No data for current day, assume closed
    }
  
    const { openTime, closeTime } = dayHours;
    return currentTime >= openTime && currentTime <= closeTime;
  }
  
  function saveRestaurantStatusToLocalStorage(restaurantId, isOpen, holidays) { 
    let restaurantStatus = isOpen ? "open" : "closed";

    if (holidays?.length > 0) {
        const today = new Date().toISOString().split("T")[0]; // Get today's date in UTC format
        
        const holidayToday = holidays.some(holiday => 
            new Date(holiday.date).toISOString().split("T")[0] === today // Convert holiday date to UTC
        );

        console.log("Today's Holiday:", holidayToday); // Debugging

        if (holidayToday) {
            restaurantStatus = "closed"; // Override if today is a holiday
        }
    }

    console.log(`Restaurant ${restaurantId} Status:`, restaurantStatus); // Debugging
    localStorage.setItem(`restaurantStatus_${restaurantId}`, restaurantStatus);
    Cookies.set(`restaurantStatus_${restaurantId}`, restaurantStatus); // Use per-restaurant cookie if needed
}

  
  useEffect(() => {
    // Function to handle resizing
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIconSize(20); // Large screen (lg)
      } else if (window.innerWidth >= 768) {
        setIconSize(15); // Medium screen (md)
      } else {
        setIconSize(10); // Small screen (sm)
      }
    };

    // Set the initial size based on screen width
    handleResize();

    // Add event listener for resizing
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

 
  // restaurant data
  console.log(restaurants.length);
  
  useEffect(() => {
    fetchRestaurantData();
  
    const interval = setInterval(() => {
      fetchRestaurantData(); // Fetch restaurant data every 2 minutes
    }, 20000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);
  
  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen); // Toggle the popup visibility
  };
  
 
 
  
  // const restaurantStatus = Cookies.get(`restaurantStatus_${RestaurantSavedId}`)
  return (
    <>
      <Header activeLink="home" onclick={()=> setIsPopupOpen(true)} />
      <Carousel />
      {/* <div className=" flex  items-center justify-between text-center  mt-16">
      <div></div>
     <div className=" flex gap-6">
     <button
          className="md:h-[63px] md:w-[171px] h-[40px] w-[100px] text-[20px] font-semibold bg-[#AD343E] text-white  rounded-[40px] font-baloo-2"
        >
          <span
            className="md:text-[20px] flex items-center justify-center body font-semibold text-[10px] "
            onClick={togglePopup}
          >
            Store Locator
          </span>
        </button>
        <button
        onClick={togglePopup}
          className="  h-[40px] text-[20px] font-semibold text-white   rounded-[40px] font-baloo-2"
        >
          <span className={`md:text-[20px] ${restaurantStatus === 'open'? 'bg-[#ad343e] text-white ': " bg-gray-200 text-gray-500"} whitespace-nowrap body font-semibold text-[10px]  flex items-center justify-center px-8 py-4 rounded-full `}>
            {nameofRestaurat || "Store Name"} 
            <div className=" flex justify-end items-end mx-3">
  <p 

    className={`${
      restaurantStatus === "open" ? " text-[#ffff]" : "bg-red-100 text-gray-500"
    }  rounded-full font-semibold flex gap-2 items-center`}
  >
   <MdInfoOutline
    className=" cursor-pointer my-tooltip"
  data-tooltip-id="my-tooltip" data-tooltip-content={restaurantStatus === 'open' 
    ? "Restaurants Is Open" 
    : "Closed"}
    />
  </p>
  <Tooltip  id="my-tooltip" />

</div>
           
           
          </span>
        </button>
     </div>
       <div></div>
       </div> */}
      


      {/* <div className="flex items-start px-4 gap-4 mt-5">
    
        {isPopupOpen && (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/20 backdrop-blur-sm animate-fade-in-up">
<div
  className="
    w-full  min-h-[95vh] rounded-2xl text-white shadow-2xl border border-border/50 
    animate-scale-in overflow-hidden bg-cover bg-center bg-no-repeat
  "
  style={{
    backgroundImage: `url(${window.innerWidth < 768 ? FinalMobileImage : finalImage})`,
  }}
>


        
        <div className="absolute inset-0 bg-black/60" />
          <div className="relative px-8 py-6 border-b border-border/50">
          <button
            variant="ghost"
            size="icon"
            onClick={()=> setIsPopupOpen(false)}
            className="absolute right-4 top-4 h-8 w-8 rounded-full hover:bg-accent"
          >
            <CgClose className="h-4 w-4" />
          </button>

          <div className="text-center body">
            <h1 className="text-3xl font-light text-foreground mb-2 text-balance">Select Your Location</h1>
            <p className="text-muted-foreground text-lg font-light">Choose a restaurant to view the menu</p>
          </div>
        </div>


        <div className="max-h-[60vh] overflow-y-auto p-6">
          <div className="space-y-4">
            {restaurants?.map((restaurant, index) => (
              <div
                key={restaurant._id}
                 onClick={() =>{
                      handleSelect(index, restaurant)
                      setSelectedRestaurant(restaurant)
                      setIsPopupOpen(false)
                    } }
                onMouseEnter={() => setHoveredId(restaurant._id)}
                onMouseLeave={() => setHoveredId(null)}
                className={`
                  group relative p-6 rounded-xl border transition-all duration-300 cursor-pointer
                  ${
                    selectedRestaurant === restaurant._id
                      ? "border-primary bg-primary/5 shadow-lg"
                      : "border-border hover:border-primary/50 hover:shadow-md bg-card"
                  }
                  ${hoveredId === restaurant._id ? "scale-[1.02]" : ""}
                `}
                style={{
                  animationDelay: `${index * 100}ms`,
                }}
              >
                <div className="flex items-center gap-6">
                 
                  <div className="relative flex-shrink-0">
                    <div className="w-16 h-16 rounded-xl overflow-hidden bg-accent border border-border/50 shadow-sm">
                      {restaurant.logo && restaurant.logo[0] ? (
                        <img
                          src={restaurant.logo[0] || "/placeholder.svg"}
                          alt={`${restaurant.title} logo`}
                          width={64}
                          height={64}
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-accent to-muted">
                          <span className="text-2xl font-semibold text-muted-foreground">
                            {restaurant.title.charAt(0).toUpperCase()}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

               
                  <div className="flex-1 min-w-0">
                    <h3 className="text-xl font-medium text-foreground mb-2 text-pretty">{restaurant.title}</h3>
                    <div className="flex items-start gap-2 text-muted-foreground">
                      <LuMapPinCheck className="h-4 w-4 mt-0.5 flex-shrink-0" />
                      <p className="text-sm leading-relaxed text-pretty">{restaurant.address}</p>
                    </div>
                  </div>

           
                  <div className="flex-shrink-0">
                    <div
                      className={`
                      w-6 h-6 rounded-full border-2 transition-all duration-200
                      ${
                        selectedRestaurant === restaurant._id
                          ? "bg-primary border-primary"
                          : "border-border group-hover:border-primary/50"
                      }
                    `}
                    >
                      {selectedRestaurant === restaurant._id && (
                        <CgCheck className="h-3 w-3 text-primary-foreground m-0.5" />
                      )}
                    </div>
                  </div>
                </div>

               
                <div
                  className={`
                  absolute inset-0 rounded-xl bg-gradient-to-r from-primary/5 to-transparent opacity-0 transition-opacity duration-300
                  ${hoveredId === restaurant._id ? "opacity-100" : ""}
                `}
                />
              </div>
            ))}
          </div>
        </div>

    
        <div className="px-8 py-6 border-t border-border/50 bg-accent/30">
          <p className="text-center text-sm text-muted-foreground">Select a location to continue with your order</p>
        </div>
      </div>
      </div>

        )}
      </div> */}
      {/* <Hero restaurantId={RestaurantSavedId} />  */}
      <Footer />
    </>
  );
};

export default HomePage;
